<template>
  <div class="container">
    <el-form :inline="true" label-width="120px" size="small">
      <el-form-item
        v-for="(item, index) in dataList"
        :key="index"
        :label="item.title"
      >
        <el-input
          v-if="item.type == 'input'"
          :placeholder="item.placeholder"
          v-model="item.value"
          clearable
        />
        <el-input
          v-if="item.type == 'number'"
          :placeholder="item.placeholder"
          v-model="item.value"
          type="number"
          clearable
        />
        <el-date-picker
          v-else-if="item.type == 'date'"
          type="date"
          value-format="yyyy-MM-dd"
          v-model="item.value"
          :placeholder="item.placeholder"
          clearable
        />
        <el-date-picker
          v-else-if="item.type == 'daterange'"
          class="date-range"
          type="daterange"
          value-format="yyyy-MM-dd"
          v-model="daterange[index]"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          range-separator="至"
          @change="dateRangeChanged(index)"
          clearable
        />
        <el-select
          v-else-if="item.type == 'option'"
          :placeholder="item.placeholder"
          v-model="item.value"
          clearable
        >
          <el-option
            v-for="option in item.options"
            :key="option.label"
            :label="option.label"
            :value="option.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="btns">
        <el-button @click.stop="reset">重置</el-button>
        <el-button type="primary" @click.stop="search">查询</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
      /*
        {
          title: "是否认证:",
          type: "option", //  input : 文本输入; option: 下拉选择; date: 日期选择;  daterange: 日期范围, number: 数字输入
          options: [
            { label: "是", value: "30" },
            { label: "否", value: "10" },
          ],                        // type == option 时传入，下拉选择项
          placeholder: "请输入",
          model: "auditStatus",     // 传出时，对象的key值， daterange时用作开始日期
          model2: "",               // 传出时，对象的第二个key值, daterange时用作结束日期
          value: "",                // 传入时，默认值
          value2: "",               // 传入时，第二个默认值
        },
      */
    },
  },
  watch: {
    dataList(newValue) {
      let ranges = {};
      newValue.forEach((item, index) => {
        if (item.type == "datarange") {
          ranges[index] = [item.value || "", item.value2 || ""];
        }
      });
      this.daterange = ranges;
    },
  },
  data() {
    return {
      daterange: {},
    };
  },
  methods: {
    // 日期范围发生变化
    dateRangeChanged(index) {
      let daterange = this.daterange[index];
      if (daterange == undefined) {
        // 清空的时候，daterange = null
        daterange = ["", ""];
      }
      if (this.dataList[index].value != undefined) {
        // 开始日期
        this.dataList[index].value = daterange[0] + " 00:00:00";
      }
      if (this.dataList[index].value2 != undefined) {
        // 结束日期
        this.dataList[index].value2 = daterange[1] + " 23:59:59";
      }
    },
    // 重置
    reset() {
      this.dataList.forEach((element) => {
        element.value = "";
        element.value2 = "";
      });
      for (let key in this.daterange) {
        this.daterange[key] = ["", ""];
      }
      this.$emit("search", {});
    },
    search() {
      let obj = {};
      this.dataList.forEach((ele) => {
        let key = ele.model;
        let value = ele.value;
        let key2 = ele.model2;
        let value2 = ele.value2;
        if (key2 != undefined && value2 != undefined) {
          obj[key2] = value2;
        }
        obj[key] = value;
      });
      this.$emit("search", obj);
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  display: inline-flex;
  justify-content: right;
  width: 120px + 250px;
}

.el-input,
.el-select,
.el-date-picker {
  width: 250px;
  margin-right: 40px;
}

.date-range {
  width: 250px;
  margin-right: 40px;
}
</style>
